module.exports = __webpack_public_path__ + "img/first-day-2.5f08a0c2.webp";